export class TextSelection
{
    public constructor(public startIndex:number,
                       public endIndex:number | null)
    {
    }

    public toString()
    {
        return `[TextSelection start: ${this.startIndex} end: ${this.endIndex}]`;
    }

    public isEqual(other:TextSelection):boolean
    {
        return other && this.startIndex === other.startIndex && this.endIndex === other.endIndex;
    }
}

export enum TextEventType
{
    TextChanged = 1,
    CursorMoved = 2,
    SelectionChanged = 3
}

export class ATextEvent
{
    public constructor(public type:TextEventType,
                       public oldText:string,
                       public newText:string,
                       public selection:TextSelection)
    {
    }

    public toString()
    {
        return `[ATextEvent type: ${this.type} old:${this.oldText} new:${this.newText} selection:${this.selection}]`;
    }
}

export type OnTextChanged = (event:ATextEvent) => (void);
